import { Group, Stack, Text, Title } from '@mantine-8/core';
import { type FC } from 'react';
import { EventName } from '../../../types/Events';
import MantineLinkButton from '../../common/MantineLinkButton';

interface Props {
    userName: string | undefined;
    projectUuid: string;
}

const LandingPanel: FC<Props> = ({ userName, projectUuid }) => {
    return (
        <Group justify="space-between" my="xl">
            <Stack justify="flex-start" gap="xs">
                <Title order={3}>
                    {`Welcome${userName ? ', ' + userName : ' to Dashball'}!`}{' '}
                    ⚡️
                </Title>
                <Text c="ldGray.7">
                    Explore the database on your own or check out the existing
                    content below:
                </Text>
            </Stack>
            <MantineLinkButton
                href={`/projects/${projectUuid}/tables`}
                bg="#CF5300"
                c="white"
                trackingEvent={{
                    name: EventName.LANDING_RUN_QUERY_CLICKED,
                    properties: {
                        projectId: projectUuid,
                    },
                }}
            >
                Explore Database
            </MantineLinkButton>
        </Group>
    );
};

export default LandingPanel;
